import { gql } from '@apollo/client';

export const EVENT_LOCATION_DETAILS = gql`
  query getEventLocationDetails($eventUuid: String!) {
    customerEvent(filter: { eventUuid: $eventUuid }) {
      date
      location_line_1
      location_line_2
      location_city
      postcode
    }
  }
`;
